import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.6 2.4H6V18h15.6V2.4zM4.8 1.2v3.6H1.2v18h18v-3.6h3.6v-18h-18zM2.4 6h2.4v13.2H18v2.4H2.4V6zm14.4 4.2l-4.8-3v6l4.8-3z" fill="#000" /></svg>;